import React, { useEffect, useState } from 'react';
import { Grid, Typography, Box } from '@material-ui/core';
import i18n from 'i18n-js';
import { Field } from 'formik';
import { useStyles } from '../ReservationRulesetCreate.styled';
import { TextField, MaterialSelectField, DisclaimerField } from 'components/FormFields';
import { useSelector } from 'react-redux';

const PaymentInputs = ({ editable = true }) => {
  
  const [payments, setPayments] = useState([
    { value: 'DEFERRED', label: i18n.t('reservation_rulesets.deferred') },
    { value: 'TRADITIONAL', label: i18n.t('reservation_rulesets.traditional') },
    {
      value: 'SUBSCRIPTION',
      label: i18n.t('reservation_rulesets.subscription'),
    },
    { value: 'WEEKLY', label: i18n.t('reservation_rulesets.weekly') },
    { value: 'ATCHECKIN', label: i18n.t('reservation_rulesets.atcheckin') },
    { value: 'DIRECT', label: i18n.t('reservation_rulesets.direct') },
  ])

  const hasFFBEnabled = useSelector(state => state.config?.settings?.core?.partnership?.sharing_type === "FFB");
  const classes = useStyles();

  useEffect( () => {
    if (hasFFBEnabled) {
      setPayments([...payments, { value: 'STATEMENT', label: i18n.t('reservation_rulesets.statement') }])
    }
  }, [hasFFBEnabled]);

  return (
    <>
      <Typography variant="h6" align="left" className={classes.rulesTitle}>
        {i18n.t('reservation_rulesets.payment_framework')}
      </Typography>
      <Field
        options={payments}
        placeholder={i18n.t('reservation_rulesets.payment_framework')}
        name="payment_framework"
        component={MaterialSelectField}
        className={classes.paymentSelect}
        editable={editable}
      />
      <Typography variant="h6" align="left" className={classes.rulesTitle}>
        {i18n.t('reservation_rulesets.at_creation')}
      </Typography>
      <Field
        data-cy="at-creation-disclaimer-input"
        component={DisclaimerField}
        editable={editable}
        name="payment_framework_settings.display_info.at_creation.disclaimer"
      />

      <Typography variant="h6" align="left" className={classes.rulesTitle}>
        {i18n.t('reservation_rulesets.at_start')}
      </Typography>
      <Field
        data-cy="at-start-disclaimer-input"
        component={DisclaimerField}
        editable={editable}
        name="payment_framework_settings.display_info.at_start.disclaimer"
      />
      <Typography variant="h6" align="left" className={classes.rulesTitle}>
        {i18n.t('reservation_rulesets.at_end')}
      </Typography>
      <Field
        data-cy="at-end-disclaimer-input"
        component={DisclaimerField}
        editable={editable}
        name="payment_framework_settings.display_info.at_end.disclaimer"
      />
      <Typography variant="h6" align="left" className={classes.rulesTitle}>
        {i18n.t('reservation_rulesets.at_cancel')}
      </Typography>
      <Field
        data-cy="at-cancel-disclaimer-input"
        component={DisclaimerField}
        editable={editable}
        name="payment_framework_settings.display_info.at_cancel.disclaimer"
      />
      <Typography variant="h6" align="left" className={classes.rulesTitle}>
        {i18n.t('reservation_rulesets.upon_modify')}
      </Typography>
      <Field
        data-cy="upon-modify-disclaimer-input"
        placeholder={i18n.t('reservation_rulesets.payment_framework')}
        name="payment_framework_settings.display_info.upon_modify.disclaimer"
        component={DisclaimerField}
        editable={editable}
      />
      <Typography variant="h6" align="left" className={classes.rulesTitle}>
        {i18n.t('reservation_rulesets.payment_details')}
      </Typography>
      <Grid container justifyContent="space-between" spacing={10}>
        <Grid item xs={6}>
          <Grid container className={classes.ruleContainer} spacing={2}>
            <Grid item xs={12} sm={9}>
              <Typography variant="h6" align="right">
                <Box fontWeight="bold" fontSize={14}>
                  {i18n.t('reservation_rulesets.pre_auth_offset')}
                </Box>
              </Typography>
              <Typography variant="body1" align="right" className={classes.description}>
                {i18n.t('reservation_rulesets.pre_auth_offset_description')}
              </Typography>
              <Typography variant="body1" align="right" className={classes.description}>
                {i18n.t('reservation_rulesets.pre_auth_offset_example')}
              </Typography>
            </Grid>
            <Grid item xs={6} sm={3}>
              <Field
                margin="none"
                label={i18n.t('reservation_rulesets.value')}
                name="payment_framework_settings.pre_auth_offset"
                component={TextField}
                required={false}
                inputProps={{ className: classes.input }}
                editable={editable}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={6}>
          <Grid container className={classes.ruleContainer} spacing={2}>
            <Grid item xs={12} sm={9}>
              <Typography variant="h6" align="right">
                <Box fontWeight="bold" fontSize={14}>
                  {i18n.t('reservation_rulesets.pre_auth_factor')}
                </Box>
              </Typography>
              <Typography variant="body1" align="right" className={classes.description}>
                {i18n.t('reservation_rulesets.pre_auth_factor_description')}
              </Typography>
              <Typography variant="body1" align="right" className={classes.description}>
                {i18n.t('reservation_rulesets.pre_auth_factor_example')}
              </Typography>
            </Grid>
            <Grid item xs={6} sm={3}>
              <Field
                margin="none"
                label={i18n.t('reservation_rulesets.value')}
                name="payment_framework_settings.pre_auth_factor"
                component={TextField}
                inputProps={{ className: classes.input }}
                editable={editable}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export { PaymentInputs };
